// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3XWts","split":"split___XxoYN","close":"close___zLf51","dragIcon":"dragIcon___gjOu_"};